// Funkcja do przewijania na górę strony
class ScrollButton {
    constructor() {
      this.mybutton = document.getElementById("scrollToTopBtn");
      window.onscroll = () => this.scrollFunction();
      if (this.mybutton) {
        this.mybutton.addEventListener("click", () => this.scrollToTop());
      }
    }
  
    scrollFunction() {
      if (document.body.scrollTop > 2000 || document.documentElement.scrollTop > 2000) {
        this.mybutton.style.display = "block";
        this.mybutton.style.opacity = "1";
      } else {
        this.mybutton.style.opacity = "0";
        this.mybutton.style.display = "none";
      }
    }
  
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  
  export default ScrollButton;